import config from "config";

const { apiControlUrl } = config;

export default {
  sessionUrl: (): string => `${apiControlUrl()}/auth/session`,
  refreshSessionUrl: (): string => `${apiControlUrl()}/auth/session/refresh`,
};
